(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown"] && !Shopify.designMode) return;
  try {
     
class FilpClock extends HTMLElement {
  constructor() {
    super();
    this.targetDate = new Date(this.getAttribute('data-countdown-input')).getTime();
    this.flipclock = this.querySelectorAll('[data-flip-clock]');
    this.timer_labels = {
      days: this.querySelector('[data-days]'),
      hours: this.querySelector('[data-hours]'),
      minutes: this.querySelector('[data-minutes]'),
      seconds: this.querySelector('[data-seconds]'),
    };
    const currentDate = new Date().getTime();
    this.remainingTime = this.targetDate - currentDate;
    var time = this.timeDifference(currentDate, this.targetDate);
    if (this.remainingTime <= 0) {

       const mainElement = this.closest('.shopify-section');
      if(this.getAttribute('data-timeout-style') == 'show')
      {
        
        mainElement.querySelector('[data-message]').classList.remove('hidden');
        mainElement.querySelector('filpclock-counter').style.display = 'none';
      }

      if(this.getAttribute('data-timeout-style') == 'hide'){
          mainElement.querySelector('filpclock-counter').style.display = 'none';
      }

      return;
    }
    
   
   
    if ('IntersectionObserver' in window === false) return;
    const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.initializeClock();
          observer.unobserve(this);
        }
    });
    }, { rootMargin: '0px 0px 700px 0px' });
    observer.observe(this);


    this.flipclock.forEach((flipClock) => { 
  var daysFirst = flipClock.querySelector('[data-days-first]');
  var hoursFirst = flipClock.querySelector('[data-hours-first]');
  var minutesFirst = flipClock.querySelector('[data-minutes-first]');
  var secondsFirst = flipClock.querySelector('[data-seconds-first]');


  if (daysFirst) {
    daysFirst.querySelector('[data-day]').value = time.days;
    daysFirst.querySelectorAll('[data-day-top]').forEach((element) => {
      element.textContent = time.days; 
    });
    daysFirst.querySelectorAll('[data-day-bottom]').forEach((element) => {
      element.textContent = time.days; 
    });
  }

  if (hoursFirst) {
    hoursFirst.querySelector('[data-hour]').value = time.hours;
    hoursFirst.querySelectorAll('[data-hour-top]').forEach((element) => {
      element.textContent = time.hours; 
    });
    hoursFirst.querySelectorAll('[data-hour-bottom]').forEach((element) => {
      element.textContent = time.hours; 
    });
  }

  if (minutesFirst) {
    minutesFirst.querySelector('[data-minute]').value = time.minutes;
    minutesFirst.querySelectorAll('[data-minute-top]').forEach((element) => {
      element.textContent = time.minutes; // Update top text for minutes
    });
    minutesFirst.querySelectorAll('[data-minute-bottom]').forEach((element) => {
      element.textContent = time.minutes; // Update bottom text for minutes
    });
  }

  if (secondsFirst) {
    secondsFirst.querySelector('[data-second]').value = time.seconds;
    secondsFirst.querySelectorAll('[data-second-top]').forEach((element) => {
      element.textContent = time.seconds; // Update top text for seconds
    });
    secondsFirst.querySelectorAll('[data-second-bottom]').forEach((element) => {
      element.textContent = time.seconds; // Update bottom text for seconds
    });
  }

});


  }

  initializeClock() {
  this.flipclock.forEach((flipClock) => { // Changed function to arrow function

    var daysFirst = this.createHandles(flipClock.querySelector('[data-days-first]'));
    var hoursFirst = this.createHandles(flipClock.querySelector('[data-hours-first]'));
    var minutesFirst = this.createHandles(flipClock.querySelector('[data-minutes-first]'));
    var secondsFirst = this.createHandles(flipClock.querySelector('[data-seconds-first]'));

    function updateClock() {
      var time = this.timeDifference(currentDate, this.targetDate); // Ensure 'this' refers to FilpClock instance
    

      this.flipDigit(daysFirst, Math.floor(time.days));

      this.flipDigit(hoursFirst, Math.floor(time.hours ));

      this.flipDigit(minutesFirst, Math.floor(time.minutes));
      this.flipDigit(secondsFirst, Math.floor(time.seconds));
   
      this.querySelector('[data-day]').value = time.days;
      this.querySelector('[data-hour]').value = time.hours;
      this.querySelector('[data-minute]').value = time.minutes;
      this.querySelector('[data-second]').value = time.seconds;
      
      if (time.total <= 0) {
        const mainElement = this.closest('.shopify-section');
      if(this.getAttribute('data-timeout-style') == 'show')
      {
        
        mainElement.querySelector('[data-message]').classList.remove('hidden');
        mainElement.querySelector('filpclock-counter').style.display = 'none';
      }

      if(this.getAttribute('data-timeout-style') == 'hide'){
          mainElement.querySelector('filpclock-counter').style.display = 'none';
      }

      return;
      
        clearInterval(timeinterval);
      }
    }
    var currentDate = new Date().getTime(); // Define currentDate here
    var timeinterval = setInterval(updateClock.bind(this), 1000); // Bind updateClock to FilpClock instance
    });
  }


  timeDifference(current, target) {
    const currentDate = new Date().getTime();
    this.remainingTime = this.targetDate - currentDate;
    const days = Math.floor(this.remainingTime / (1000 * 60 * 60 * 24));
    const hours = Math.floor((this.remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((this.remainingTime % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((this.remainingTime % (1000 * 60)) / 1000);

    return {
      'total': this.remainingTime,
      'days': days,
      'hours': hours,
      'minutes': minutes,
      'seconds': seconds
    };
  }

  createHandles(flipElement) {
    var flipperTop = flipElement.querySelector("[flipper-top]");
    var flipperBottom = flipElement.querySelector("[flipper-bottom]");
    var flipperDisplayTop = flipElement.querySelector("[flip-display-top]");
    var flipperDisplayBottom = flipElement.querySelector("[flip-display-bottom]");
    var flipHiddenInput = flipElement.querySelector("[type='hidden']");
    return {
      flipElement,
      flipperTop,
      flipperBottom,
      flipperDisplayBottom,
      flipperDisplayTop,
      flipHiddenInput,
    };
  }

  flipDigit(flipHandles, digitValue) {
    var {
      flipElement,
      flipperTop,
      flipperBottom,
      flipperDisplayBottom,
      flipperDisplayTop,
      flipHiddenInput,
    } = flipHandles;

    var setPreviousValue = function(value) {
      flipperTop.innerText = value;
      flipperDisplayBottom.innerText = value;
    };
    var setAfterValue = function(value) {
      flipperDisplayTop.innerText = value;
      flipperBottom.innerText = value;
    };

    if (parseInt(flipHiddenInput.value) !== digitValue) {
      setPreviousValue(flipHiddenInput.value);
      flipHiddenInput.value = digitValue;
      var valueChangedEvent = new Event('valueChanged');
      flipHiddenInput.dispatchEvent(valueChangedEvent);
    }

    flipHiddenInput.addEventListener('valueChanged', function() {
      setAfterValue(flipHiddenInput.value);
      flipElement.classList.add("play");
    });

    flipperBottom.addEventListener('animationend', function() {
      setAfterValue(flipHiddenInput.value);
      setPreviousValue(flipHiddenInput.value);
      flipElement.classList.remove("play");
    });
  }
}
customElements.define('filpclock-counter', FilpClock);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
     
class FeatureProducts extends HTMLElement {
  constructor() {
    super();
    this.onScrollBound = this.onScroll.bind(this);
  }

  connectedCallback() {
    window.addEventListener('scroll', this.onScrollBound, { passive: true });
    this.onScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollBound);
  }

  onScroll() {
    const currentSection = this.closest('.shopify-section');
    if (!currentSection) return;
    const offsetSection = currentSection.getBoundingClientRect();

    if (offsetSection.top < window.innerHeight && offsetSection.bottom > 70) {
      this.classList.add('is-active');
    }
  }
}

customElements.define('feature-products', FeatureProducts);



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    

  document.addEventListener('DOMContentLoaded', () => {
    const applyAccordionState = () => {
      const showAccordionOnMobile =
        document.querySelector('[data-show-accordion]')?.getAttribute('data-show-accordion') === 'true';
      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      document.querySelectorAll('details[data-accordion]').forEach((el) => {
        if (showAccordionOnMobile && isMobile) {
          // Show accordion on mobile if setting allows
          el.removeAttribute('open', '');
        } else if (!showAccordionOnMobile && isMobile) {
          // Do not show accordion on mobile if setting disallows
          el.setAttribute('open',true);
        } else if (!isMobile) {
          // On desktop, always open accordions
          el.setAttribute('open', '');
        }
      });
    };
    applyAccordionState();
    window.addEventListener('resize', applyAccordionState);
    document.addEventListener('shopify:section:load', (event) => {
      // Apply accordion state when a new section is loaded
      applyAccordionState();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class Sizechart extends HTMLElement {
    constructor() {
      super();
      this.querySelector('[data-size-chart]').addEventListener('click', this.init.bind(this));
    }

    init(e) {
      e.preventDefault();
      const popupModal = this.querySelector('popup-modal');
      popupModal.modalPopupOpen('data-size-chart-popup');
    }
  }
  customElements.define('size-chart', Sizechart);

  class ProgressBar extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.style.setProperty('--progress_width', `${parseInt(this.dataset.value) * 0.75 * 100 / parseInt(this.dataset.max)}%`);
  }
}
customElements.define('progress-bar', ProgressBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotional-bar"] && !Shopify.designMode) return;
  try {
    
  class PromotionalBar extends HTMLElement {
    constructor() {
      super();

      const popupModal = this.querySelector('popup-modal');

      this.videos = this.querySelectorAll('[promotional-bar-video]');

      this.videos.forEach((video) => {
        video.addEventListener('click', () => {
          const videoId = video.getAttribute('data-id');
          console.log(videoId);
          popupModal.modalPopupOpen(`data-video-popup-${videoId}`);
        });
      });
    }
  }

  customElements.define('promotional-bar', PromotionalBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-with-icon"] && !Shopify.designMode) return;
  try {
     
class Textwithicon extends HTMLElement{
  constructor() {
    super();
    const resizeObserver = new ResizeObserver(this.getHeight.bind(this));
    resizeObserver.observe(this);
    //this.getHeight();
  }
  getHeight(){
    this.divElement = this.querySelectorAll("[data-text-icon-desc]");
    this.divElement.forEach(element => {
      this.elemHeight = element.getBoundingClientRect().height;
      let closestParent = element.closest('[data-text-icon-inner]');
      if (closestParent) {
    
        closestParent.style.setProperty('--description_height', `${this.elemHeight}px`);
      }
    });
  }
}
customElements.define('text-with-icon', Textwithicon);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
     
class AnimatedCursor extends HTMLElement {
  constructor() {
    super();

    this.mouse = { x: -100, y: -100 };
    this.pos = { x: 0, y: 0 };
    this.speed = 0.15;
    this.element = null; // Keep track of the current element with cursor class

    
    //window.addEventListener('mousedown', this.startDrag.bind(this));
   // window.addEventListener('mouseup', this.endDrag.bind(this));

    const cursorPointer = this.closest('.section-video');

    if(! cursorPointer){ 
      cursorModifier.addEventListener('pointermove', this.removeCursor.bind(this));  
        return; 
      }
    // window.addEventListener('mousedown', this.startDrag.bind(this));
    cursorPointer.querySelectorAll('[cursor-class]').forEach((cursorModifier) => {
     cursorModifier.addEventListener('pointermove', this.updateCoordinates.bind(this));
      cursorModifier.addEventListener('mouseenter', this.addCursorClass.bind(this));
      cursorModifier.addEventListener('mouseleave', this.removeCursorClass.bind(this));
      cursorModifier.addEventListener('mouseout', this.removeCursor.bind(this));
      cursorModifier.addEventListener('scroll', () => {
        console.log('Scroll event fired');
      });
      cursorModifier.addEventListener('pointermove', this.removeCursor.bind(this));
      cursorModifier.addEventListener('mouseup', this.endDrag.bind(this));
      cursorModifier.addEventListener('mousedown', this.startDrag.bind(this)); // Add mousedown event here
    });

    requestAnimationFrame(this.loop.bind(this));
  }

  startDrag(e) {
    this.updateCoordinates(e);
  }

  endDrag(e) {
    this.updateCoordinates(e);
  }

  removeCursor(event) {
    this.element = event.currentTarget;
    const className = this.element.getAttribute('cursor-class');
    this.elementName = event.target.tagName;
  }

  handleScroll(e){
    console.log("wqewqe");
  }
  updateCoordinates(e) {
    this.mouse.x = e.clientX;
    this.mouse.y = e.clientY;
  }

  getAngle(diffX, diffY) {
    return (Math.atan2(diffY, diffX) * 180) / Math.PI;
  }

  getSqueeze(diffX, diffY) {
    const distance = Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2));
    const maxSqueeze = 0.0;
    const accelerator = 1500;
    return Math.min(distance / accelerator, maxSqueeze);
  }

  updateCursor() {
    const diffX = Math.round(this.mouse.x - this.pos.x);
    const diffY = Math.round(this.mouse.y - this.pos.y);

    this.pos.x += diffX * this.speed;
    this.pos.y += diffY * this.speed;

    const angle = this.getAngle(diffX, diffY);
    const squeeze = this.getSqueeze(diffX, diffY);

    // Update cursor style with transformations
    this.style.translate = `${this.pos.x}px ${this.pos.y}px`;
    //this.style.transform = `scale(${2 + squeeze}, ${2 - squeeze}) rotate(${angle}deg) translate3d(${this.pos.x}px, ${this.pos.y}px, 0)`;
  }

  loop() {
    this.updateCursor();
    requestAnimationFrame(this.loop.bind(this));
  }

  addCursorClass(event) {
    this.element = event.currentTarget;
    const className = this.element.getAttribute('cursor-class');
    if (className === 'video') {
      this.classList.add('king_cursor');
      this.videoButton = this.element.querySelector('[data-content-button]');
     
      if(this.videoButton){
      this.videoButton.style.display = "none";
      }
      this.innerHTML = this.videoButton.innerHTML;
    }
  }

  removeCursorClass(event) {
    const element = event.currentTarget;
    console.log(element);
    const className = element.getAttribute('cursor-class');
    if (className === 'video') {
      this.videoButton = this.element.querySelector('[data-content-button]');
      if(this.videoButton){
      this.videoButton.style.display = "block";
      }
      this.innerHTML = '';
      this.classList.remove('king_cursor');
    }
  }
}

customElements.define('animated-cursor', AnimatedCursor);


  } catch(e) { console.error(e); }
})();
})();
